// @ts-ignore
import {DateTime} from 'luxon';
import {Trade} from "../../model/clearing/trade";
import {CrystalclearBackUrl} from "./crystalclear-back-url";
import {TableRecordResult} from "../../model/api/table-record-result";
import {Order} from "../../model/clearing/order";
import {ApiValidation} from "../../model/api/api-validation";
import {OrderPof} from "../../model/clearing/order-pof";
import {SyncMetadata} from "../../model/api/sync-metadata";
import {ClearingSelectionInfo} from "../../model/clearing/clearing-selection-info";
import {AllocationTask} from "../../model/clearing/allocation/allocation-task";
import {SignificantOrdersInfo} from "../../model/clearing/significant-orders-info";
import {PlResidualInfo} from "../../model/clearing/pl-residual-info";
import {ClearingSelectionSummary} from "../../model/clearing/clearing-selection-summary";
import {FieldResult} from "../../model/api/field-result";

export class CrystalclearClearingBackUrl {
  static readonly GET_CLEARING_ALLOCATION_SINGLE_ALLOCATION: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/single-allocation',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_UPDATE_SINGLE_ALLOCATION: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/update-single-allocation',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_SPLIT_ALLOCATION: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/split-allocation',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_UPDATE_SPLIT_ALLOCATION: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/update-split-allocation',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_APPROVE_APSLEG: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/approve-aps-leg',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_APPROVE_APSWHOLEORDER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/approve-aps-whole-order',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_EXCHANGE_OVERRIDE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/override-aps',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_EXCHANGE_OVERRIDE_OPTIMIZE_RESIDUAL: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/optimize-aps-group',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_DELETE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/delete',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_REQUEST_REVERSAL: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/request-reversal',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_CANCEL_REVERSAL: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/cancel-reversal',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_REQUEST_REVERSAL_CLEARING: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/request-reversal-clearing',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_CANCEL_REVERSAL_CLEARING: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/cancel-reversal-clearing',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_ACCEPT_REVERSAL: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/accept-reversal',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_REJECT_REVERSAL: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/reject-reversal',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_GET_FULL_TRADES: CrystalclearBackUrl.UrlConf<ApiValidation<Trade[]>> = {
    url: '/api/clearing/allocation/get-full-trades',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_GET_SIGNIFICANT_TRADES: CrystalclearBackUrl.UrlConf<ApiValidation<Trade[]>> = {
    url: '/api/clearing/allocation/get-significant-trades',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_GET_SIGNIFICANT_TRADES_FROM_CLEARINGS: CrystalclearBackUrl.UrlConf<ApiValidation<Trade[]>> = {
    url: '/api/clearing/allocation/get-significant-trades-from-clearings',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_GET_SIGNIFICANT_CLEARING_ORDERS: CrystalclearBackUrl.UrlConf<ApiValidation<Order[]>> = {
    url: '/api/clearing/allocation/get-significant-clearing-orders',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_GET_SIGNIFICANT_ORDERS: CrystalclearBackUrl.UrlConf<ApiValidation<SignificantOrdersInfo>> = {
    url: '/api/clearing/allocation/get-significant-orders',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_GET_ORDER_DETAIL: CrystalclearBackUrl.UrlConf<ApiValidation<Order>> = {
    url: '/api/clearing/allocation/get-order-detail',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_GET_WHOLE_ORDER: CrystalclearBackUrl.UrlConf<ApiValidation<Order[]>> = {
    url: '/api/clearing/allocation/get-whole-order',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ALLOCATION_GET_ORDER_LEG: CrystalclearBackUrl.UrlConf<ApiValidation<Order[]>> = {
    url: '/api/clearing/allocation/get-order-leg',
    type: ApiValidation
  };
  static readonly POST_CLEARING_ALLOCATION_DISABLE_ORDER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/disable-order',
    type: ApiValidation
  };
  static readonly POST_CLEARING_ALLOCATION_MOVE_ORDERS: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/move-orders',
    type: ApiValidation
  };
  static readonly POST_CLEARING_ALLOCATION_CANCEL_CLEARING_ERROR: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/cancel-clearing-error',
    type: ApiValidation
  };
  static readonly POST_CLEARING_ALLOCATION_CANCEL_PENDING_CLEARING: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/cancel-pending-clearing',
    type: ApiValidation
  };
  static readonly POST_CLEARING_ALLOCATION_RESEND_CLEARING: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/resend-clearing',
    type: ApiValidation
  };
  static readonly POST_CLEARING_ALLOCATION_FORCE_CLEAR: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/force-clear',
    type: ApiValidation
  };
  static readonly POST_CLEARING_ALLOCATION_DELETE_CLEARING_ERROR: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/delete-clearing-error',
    type: ApiValidation
  };
  static readonly POST_CLEARING_ALLOCATION_OVERRIDE_CUSTOM_REFERENCE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/override-custom-reference',
    type: ApiValidation
  };
  static readonly POST_CLEARING_ALLOCATION_UPDATE_TRADE_PRICE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/allocation/update-trade-price',
    type: ApiValidation
  };
  static readonly GET_CLEARING_ORDERS_POF: CrystalclearBackUrl.UrlConf<TableRecordResult<OrderPof>> = {
    url: '/api/clearing/order-pof/list',
    type: TableRecordResult
  };
  static readonly GET_CLEARING_TASK_CHECK: CrystalclearBackUrl.UrlConf<ApiValidation<AllocationTask>> = {
    url: '/api/clearing/allocation-tasks/check',
    type: ApiValidation
  };
  static readonly GET_CLEARING_TASK_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<AllocationTask>> = {
    url: '/api/clearing/allocation-tasks/list',
    type: TableRecordResult
  };
  static readonly GET_CLEARING_PL_RESIDUAL_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<PlResidualInfo>> = {
    url: '/api/clearing/pl-residual/list/clearing-ids',
    type: TableRecordResult
  };

  static readonly GET_CLEARING_PL_RESIDUAL_ORDER_IDS: CrystalclearBackUrl.UrlConf<TableRecordResult<PlResidualInfo>> = {
    url: '/api/clearing/pl-residual/list/order-ids',
    type: TableRecordResult
  };

  static readonly GET_CLEARING_TRADE_INFO_SELECTION_SUMMARY: CrystalclearBackUrl.UrlConf<ApiValidation<ClearingSelectionSummary[]>> = {
    url: '/api/clearing/trade-info/selection-info-summary',
    type: ApiValidation
  };


  static readonly GET_CLEARING_TRADE_INFO_SELECTION_INFO_LEGS: CrystalclearBackUrl.UrlConf<ApiValidation<ClearingSelectionInfo[]>> = {
    url: '/api/clearing/trade-info/selection-info-legs',
    type: ApiValidation
  };

  static readonly TRADE_ALLOCATION_APPROVAL: CrystalclearBackUrl.UrlConf<ApiValidation<Boolean>> = {
    url: '/api/clearing/trade-info/trade-allocation-approval',
    type: ApiValidation
  };

  static readonly GET_CLEARING_ORDER_INFO_SELECTION_SUMMARY: CrystalclearBackUrl.UrlConf<ApiValidation<ClearingSelectionSummary[]>> = {
    url: '/api/clearing/order-info/selection-info-summary',
    type: ApiValidation
  };

  static readonly GET_CLEARING_ORDER_INFO_SELECTION_SUMMARY_TRADE_MODE: CrystalclearBackUrl.UrlConf<ApiValidation<ClearingSelectionSummary[]>> = {
    url: '/api/clearing/order-info/selection-info-summary-trade-mode',
    type: ApiValidation
  };

  static readonly GET_CLEARING_ORDER_INFO_SELECTION_INFO_LEGS: CrystalclearBackUrl.UrlConf<ApiValidation<ClearingSelectionInfo[]>> = {
    url: '/api/clearing/order-info/selection-info-legs',
    type: ApiValidation
  };

  static readonly GET_CLEARING_ORDER_INFO_SELECTION_INFO_LEGS_TRADE_MODE: CrystalclearBackUrl.UrlConf<ApiValidation<ClearingSelectionInfo[]>> = {
    url: '/api/clearing/order-info/selection-info-legs-trade-mode',
    type: ApiValidation
  };

  static readonly GET_CLEARING_FLEX_ORDER_TEMPLATES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/clearing/flex/order-templates',
    type: FieldResult
  };

  static readonly GET_CLEARING_FLEX_TRADE_TEMPLATES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/clearing/flex/trade-templates',
    type: FieldResult
  };

  static readonly POST_CLEARING_FLEX_ORDERS_REQUEST: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/flex/orders-request',
    type: ApiValidation
  };

  static readonly POST_CLEARING_FLEX_TRADES_REQUEST: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/flex/trades-request',
    type: ApiValidation
  };

  static readonly POST_CLEARING_FLEX_DELETE_TRADES: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/flex/delete-trades',
    type: ApiValidation
  };

  static readonly POST_CLEARING_FLEX_SAVE_BATCH: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/clearing/flex/save-batch',
    type: ApiValidation
  };



}
